import { render, staticRenderFns } from "./ClassPlanCard.vue?vue&type=template&id=3035fa43&scoped=true"
import script from "./ClassPlanCard.vue?vue&type=script&lang=js"
export * from "./ClassPlanCard.vue?vue&type=script&lang=js"
import style0 from "./ClassPlanCard.vue?vue&type=style&index=0&id=3035fa43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035fa43",
  null
  
)

export default component.exports